import { render, staticRenderFns } from "./thakyouPage.vue?vue&type=template&id=1c820992&scoped=true&"
import script from "./thakyouPage.vue?vue&type=script&lang=js&"
export * from "./thakyouPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c820992",
  null
  
)

export default component.exports